import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { signUpApi } from "../api/auth";

const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    const { error } = await signUpApi(email, password);
    if (error) {
      setError(error.message);
    } else {
      setMessage("Check your email to confirm your account.");
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 400 }}>
        <Typography
          component={RouterLink}
          to="/"
          variant="h6"
          sx={{
            display: "block",
            textAlign: "center",
            mb: 5,
            color: "black",
            textDecoration: "none",
            fontWeight: 700,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
          }}
        >
          Lemanade
        </Typography>

        <Typography
          variant="subtitle2"
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontWeight: 700,
            mb: 4,
          }}
        >
          Create Account
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: 0 }}>
            {error}
          </Alert>
        )}
        {message && (
          <Alert severity="success" sx={{ mb: 2, borderRadius: 0 }}>
            {message}
          </Alert>
        )}

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: 0 },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d4d4d4" },
            }}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
            size="small"
            slotProps={{ htmlInput: { minLength: 6 } }}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: 0 },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d4d4d4" },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              bgcolor: "black",
              color: "white",
              py: 1.5,
              fontSize: "0.75rem",
              letterSpacing: "0.12em",
              mt: 1,
              "&:hover": { bgcolor: "#333" },
            }}
          >
            {loading ? "Please wait…" : "Create Account"}
          </Button>
        </Box>

        <Typography
          variant="body2"
          sx={{ textAlign: "center", mt: 4, color: "#737373" }}
        >
          Already have an account?{" "}
          <Typography
            component={RouterLink}
            to="/login"
            variant="body2"
            sx={{
              color: "black",
              fontWeight: 600,
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Sign in
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};

export default SignupPage;
